import { useEffect, useState } from "react";

const QUERY = "(min-width: 1024px)";

function read() {
  return typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(QUERY).matches
    : false;
}

/** True at the desktop-composition breakpoint (≥1024px). False where matchMedia is unavailable (tests). */
export function useIsDesktopViewport() {
  const [isDesktop, setIsDesktop] = useState(read);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    const media = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(media.matches);
    onChange();
    media.addEventListener?.("change", onChange);
    return () => media.removeEventListener?.("change", onChange);
  }, []);

  return isDesktop;
}
